"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DynamicTable = void 0;
var _clsx = _interopRequireDefault(require("clsx"));
var _react = _interopRequireWildcard(require("react"));
var _external = require("../external");
var _Tooltip = require("../Tooltip");
var _DynamicTable = require("./DynamicTable.styles");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _proRegularSvgIcons = require("@fortawesome/pro-regular-svg-icons");
var _reactNumberFormat = _interopRequireDefault(require("react-number-format"));
var _AddAdditionalRowDropdown = _interopRequireDefault(require("./AddAdditionalRowDropdown"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var DynamicTable = function DynamicTable(_ref) {
  var columns = _ref.columns,
    data = _ref.data,
    testId = _ref.testId,
    moveFocusToFirstTextField = _ref.moveFocusToFirstTextField,
    scrollable = _ref.scrollable,
    scrollableMaxHeight = _ref.scrollableMaxHeight,
    padding = _ref.padding,
    addAdditionalRow = _ref.addAdditionalRow,
    additionalRowProps = _ref.additionalRowProps;
  var classes = (0, _DynamicTable.useStyles)({
    scrollable: scrollable,
    scrollableMaxHeight: scrollableMaxHeight,
    padding: padding
  });
  var _useState = (0, _react.useState)(null),
    _useState2 = _slicedToArray(_useState, 2),
    focusedTextField = _useState2[0],
    setFocusedTextField = _useState2[1];
  var focusedTextFieldRef = /*#__PURE__*/(0, _react.createRef)();
  (0, _react.useEffect)(function () {
    if (moveFocusToFirstTextField) {
      var _focusedTextFieldRef$;
      (_focusedTextFieldRef$ = focusedTextFieldRef.current) === null || _focusedTextFieldRef$ === void 0 ? void 0 : _focusedTextFieldRef$.focus();
    }
  }, [moveFocusToFirstTextField]);
  var renderTableBody = function renderTableBody(items) {
    return items.map(function (record, i) {
      var _Object$values$find;
      var error = (_Object$values$find = Object.values(record).find(function (value) {
        return value.error;
      })) === null || _Object$values$find === void 0 ? void 0 : _Object$values$find.error;
      var focusedBorder = error ? '1px solid #A62B23' : '1px solid #1E8777';
      return (
        /*#__PURE__*/
        // style the tooltip so that it is positioned at the
        _react["default"].createElement(_Tooltip.Tooltip, {
          title: error || '',
          classes: {
            tooltip: classes.errorTooltip
          }
        }, /*#__PURE__*/_react["default"].createElement(_external.TableRow, {
          key: i,
          className: error ? classes.tableRowError : classes.tableRow
        }, columns.map(function (column, j) {
          var _record$column$access, _record$column$access2, _record$column$access3, _record$column$access4, _record$column$access5, _record$column$access6, _record$column$access7, _record$column$access8, _record$column$access9;
          var cellId = "".concat(i, "-").concat(column.accessor);
          var border = (_record$column$access = record[column.accessor].border) !== null && _record$column$access !== void 0 ? _record$column$access : undefined;
          var borderLeft = (_record$column$access2 = record[column.accessor].borderLeft) !== null && _record$column$access2 !== void 0 ? _record$column$access2 : undefined;
          return /*#__PURE__*/_react["default"].createElement(_external.TableCell, {
            key: j,
            style: {
              border: focusedTextField === cellId ? focusedBorder : border,
              borderLeft: focusedTextField === cellId ? focusedBorder : borderLeft
            }
          }, j === 0 && error && /*#__PURE__*/_react["default"].createElement("span", {
            style: {
              marginRight: '6px'
            }
          }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
            icon: _proRegularSvgIcons.faExclamationCircle
          })), record[column.accessor].numericalInput ? /*#__PURE__*/_react["default"].createElement(_Tooltip.Tooltip, {
            title: (_record$column$access3 = (_record$column$access4 = record[column.accessor].inputProps) === null || _record$column$access4 === void 0 ? void 0 : _record$column$access4.tooltip) !== null && _record$column$access3 !== void 0 ? _record$column$access3 : '',
            classes: {
              tooltip: classes.tooltip
            }
          }, /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_reactNumberFormat["default"], {
            fullWidth: true,
            thousandSeparator: true,
            disableUnderline: true,
            allowLeadingZeros: false,
            type: "text",
            placeholder: (_record$column$access5 = record[column.accessor].inputProps) === null || _record$column$access5 === void 0 ? void 0 : _record$column$access5.inputPlaceholder,
            onChange: (_record$column$access6 = record[column.accessor].inputProps) === null || _record$column$access6 === void 0 ? void 0 : _record$column$access6.onChange,
            value: String((_record$column$access7 = record[column.accessor].inputProps) === null || _record$column$access7 === void 0 ? void 0 : _record$column$access7.value) || '',
            error: !!record[column.accessor].error,
            inputProps: {
              style: {
                marginLeft: '8px'
              }
            },
            disabled: (_record$column$access8 = record[column.accessor].inputProps) === null || _record$column$access8 === void 0 ? void 0 : _record$column$access8.disabled,
            className: (_record$column$access9 = record[column.accessor].inputProps) === null || _record$column$access9 === void 0 ? void 0 : _record$column$access9.className,
            customInput: _external.Input,
            onFocus: function onFocus() {
              setFocusedTextField(cellId);
            },
            onBlur: function onBlur() {
              setFocusedTextField(null);
            },
            inputRef: i === 0 ? focusedTextFieldRef : undefined
          }))) : /*#__PURE__*/_react["default"].createElement("span", {
            className: (0, _clsx["default"])(column.columnStyle, error && classes.error)
          }, record[column.accessor].value));
        })))
      );
    });
  };
  var tableHead = /*#__PURE__*/_react["default"].createElement(_external.TableHead, null, /*#__PURE__*/_react["default"].createElement(_external.TableRow, null, columns.map(function (column, i) {
    return /*#__PURE__*/_react["default"].createElement(_external.TableCell, {
      key: i,
      style: {
        width: column.width
      }
    }, column.header);
  })));
  return /*#__PURE__*/_react["default"].createElement(_external.TableContainer, {
    className: classes.tableContainer
  }, /*#__PURE__*/_react["default"].createElement(_external.ClickAwayListener, {
    onClickAway: function onClickAway() {
      return additionalRowProps === null || additionalRowProps === void 0 ? void 0 : additionalRowProps.setOpenAdditionalRowDropdown(false);
    }
  }, /*#__PURE__*/_react["default"].createElement(_external.Table, {
    "data-testid": testId,
    className: (0, _clsx["default"])(classes.table)
  }, tableHead, data && data.length > 0 ? /*#__PURE__*/_react["default"].createElement(_external.TableBody, null, renderTableBody(data)) : null, addAdditionalRow &&
  /*#__PURE__*/
  // @ts-ignore
  _react["default"].createElement(_AddAdditionalRowDropdown["default"], {
    classes: classes,
    additionalRowProps: additionalRowProps !== null && additionalRowProps !== void 0 ? additionalRowProps : {}
  }))));
};
exports.DynamicTable = DynamicTable;